// Motivo con el que el monitor pausa a un agente vía AMI. Asterisk lo conserva y
// lo devuelve como `PausedReason` en QueueMemberGrouped, así que es lo que
// distingue una pausa forzada por un supervisor —que el agente no puede
// reanudar— de la que él mismo eligió del catálogo, cuyo motivo es el nombre de
// su pausa.
//
// Debe coincidir con ADMIN_PAUSE_NAME en
// callcenter-backend/app/pause/constants.py. Es estable: esa fila está oculta
// del catálogo y el backend rechaza crear o renombrar otra pausa con ese nombre.
export const ADMIN_PAUSE_REASON = 'Pausa de Administrador'

export const isAdminPauseReason = (reason?: string | null) =>
  reason?.trim() === ADMIN_PAUSE_REASON
